module.exports = "https://coursera_assets.s3.amazonaws.com/images/b3fb24084066642491c1f47c997b8234.png";